module.exports = __webpack_public_path__ + "img/logo3.1c230af7.svg";